import styles from "./styles.module.scss";

export type DirectionType = 1 | -1;
export type OnNavigationType = (direction: any) => void;
interface ProgressBarProps {
  onNavigation: OnNavigationType;
  backText?: string;
  nextText?: string;
  nextButtonArrow?: boolean;
  selected?: number[];
}

const SlideNavigation: React.FC<ProgressBarProps> = ({
  onNavigation,
  backText,
  nextText,
  nextButtonArrow,
  selected,
}) => {
  return (
    <div
      className={`${styles.navigationContainer} ${
        !backText && styles.nextNavigation
      }`}>
      {backText && (
        <p
          className={`${styles.buttons} ${styles.backButton}`}
          onClick={() => {
            onNavigation(-1);
          }}>
          <span style={{ fontSize: 20, fontWeight: "bold" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="24"
              width="25"
              role="presentation"
              aria-labelledby="icon-arrow-left"
              fill="none"
              focusable="false"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="currentColor"
              strokeWidth="1.5"
              className="">
              <title id="arrowLeft">arrowLeft</title>
              <g>
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
                <line x1="5" y1="12" x2="19" y2="12"></line>{" "}
                <line x1="5" y1="12" x2="11" y2="18"></line>{" "}
                <line x1="5" y1="12" x2="11" y2="6"></line>
              </g>
            </svg>
          </span>{" "}
          {backText}
        </p>
      )}
      {nextText && selected && selected.length > 0 && (
        <p
          className={`${styles.buttons} ${styles.nextButton}`}
          onClick={() => {
            onNavigation(1);
          }}
          style={{ marginLeft: "10px" }}>
          {nextText}{" "}
          <span style={{ fontSize: 25, fontWeight: "bold" }}>
            {nextButtonArrow && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                height="24"
                width="25"
                role="presentation"
                aria-labelledby="icon-arrow-left"
                fill="none"
                focusable="false"
                strokeLinecap="round"
                stroke-linejoin="round"
                stroke="currentColor"
                strokeWidth="1.5"
                className="">
                <title id="arrowRight">arrowRight</title>
                <g>
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>{" "}
                  <line x1="5" y1="12" x2="19" y2="12"></line>{" "}
                  <line x1="13" y1="18" x2="19" y2="12"></line>{" "}
                  <line x1="13" y1="6" x2="19" y2="12"></line>
                </g>
              </svg>
            )}
          </span>
        </p>
      )}
    </div>
  );
};

export default SlideNavigation;
